<template>
  <el-form ref="form" :rules="rules" :model="form" label-width="80px" :label-position="labelPosition">
    <el-form-item label="原密码" prop="oldPsw">
      <el-input show-password v-model="form.oldPsw" :readonly="readonly" @focus="onFocus"></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="newPsw">
      <el-input show-password v-model="form.newPsw"></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="rePsw">
      <el-input show-password v-model="form.rePsw"></el-input>
    </el-form-item>

    <el-form-item class="btn">
      <el-button :size="btnSize" type="primary" @click="onSubmit('form')">提交</el-button>
      <el-button :size="btnSize" @click="onBack">返回</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: "UpdatePassword",
    data() {
      /*
    * 密码校验
    * */
      //新密码
      const validPsw = (rule, value, callback) => {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/
        if (!value) {
          callback(new Error('密码不能为空'));
        } else if (!reg.test(value)) {
          callback(new Error('格式应包含字母和数字，长度为6-10'));
        } else {
          callback();
        }
      }
      //确认密码
      const validatePsw = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请确认密码'));
        } else if (value !== this.form.newPsw) {
          callback(new Error('与新密码输入不一致'));
        } else {
          callback();
        }
      }
      return {
        readonly: true,
        btnSize:'medium',
        labelPosition:'left',
        form: {
          username: '',
          oldPsw: '',
          newPsw: '',
          rePsw: ''
        },
        rules: {
          oldPsw: [
            {required: true, message: '请输入原始密码', trigger: 'blur'},
          ],
          newPsw: [
            {required: true, validator: validPsw, trigger: 'blur'},
          ],
          rePsw: [
            {required: true, validator: validatePsw, trigger: 'blur'},
          ]
        }
      }

    },
    methods: {
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.form.username) {
              this.$http.post("https://yuanteng.tech:8081/user/updatePsw", this.form).then(res => {
                if (res.data.status) {
                  this.$message({
                    message: res.data.msg + '请重新登录',
                    type: 'success'
                  });
                  localStorage.removeItem("access-admin");
                  this.$router.push('/login')
                } else {
                  this.$message.error(res.data.msg)
                }
              })
            }
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },
      onBack() {
        this.$router.push('/index/home');
      },
      onFocus() {
        this.readonly = false;
      },
      handleResize(){
        if(window.innerWidth < 768 && window.innerWidth >= 330){
          this.btnSize = 'small';
          this.labelPosition = 'left';
        }else if(window.innerWidth < 330){
          this.btnSize = 'mini';
          this.labelPosition = 'top';
        } else {
          this.btnSize = 'medium';
          this.labelPosition = 'left';
        }
      }
    },
    created() {
      this.form = {}
      const username = (JSON.parse(window.localStorage.getItem("access-admin"))).username || '';
      // console.log(this.readonly)
      this.form.username = decodeURIComponent(window.atob(username));
      this.handleResize();
      window.addEventListener('resize',this.handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.handleResize);
    }
  }
</script>

<style scoped>
  .el-form {
    max-width: 300px;
  }
  @media screen {
    /deep/.el-form--label-top .el-form-item__label {
      padding: 0 !important;
    }
  }
  @media screen and (max-width: 330px){
    /deep/ .btn .el-form-item__content{
      margin-left: 20px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/update/UpdatePassword.vue